import { render, staticRenderFns } from "./bill.vue?vue&type=template&id=64bed474&scoped=true&"
import script from "./bill.vue?vue&type=script&lang=js&"
export * from "./bill.vue?vue&type=script&lang=js&"
import style0 from "./bill.vue?vue&type=style&index=0&id=64bed474&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bed474",
  null
  
)

export default component.exports